var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7284 4.81926L6.8588 3H2.1848C1.66832 3 1.25 3.40706 1.25 3.90963V19.3734C1.25 20.3781 2.08711 21.1926 3.1196 21.1926H20.8808C21.9133 21.1926 22.7504 20.3781 22.7504 19.3734V6.63853C22.7504 5.63384 21.9133 4.81926 20.8808 4.81926H8.7284Z",
    fill: "url(#paint0_linear_4166_311997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7504 7.41034H1.25V3.88207C1.25 3.39473 1.66832 3 2.1848 3H6.8588L8.7284 4.76413H20.8808C21.9133 4.76413 22.7504 5.55403 22.7504 6.52827V7.41034Z",
    fill: "url(#paint1_linear_4166_311997)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1996 7.4108H1.80176C1.80176 6.13322 1.80253 5.27198 1.80235 4.10345C1.8023 3.79889 2.04915 3.55176 2.3537 3.55176H6.76339L8.69291 5.34346L20.8185 5.31871C21.5808 5.31716 22.1996 5.93488 22.1996 6.69716C22.1996 7.0664 22.1996 7.3451 22.1996 7.4108Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7504 7.4105H1.25V5.81176C1.25 5.32441 1.66832 4.92969 2.1848 4.92969H6.8588L8.7284 6.69382H22.7504C22.7504 7.13486 22.7504 7.13486 22.7504 7.4105Z",
    fill: "#63B4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7504 7.4105H1.25V5.81176C1.25 5.32441 1.66832 4.92969 2.1848 4.92969H6.8588L8.7284 6.69382H22.7504C22.7504 7.13486 22.7504 7.13486 22.7504 7.4105Z",
    fill: "url(#paint2_linear_4166_311997)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4166_311997",
    x1: 1.50084,
    y1: 4.38264,
    x2: 23.0688,
    y2: 5.53446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1088E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1966AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4166_311997",
    x1: 1.50084,
    y1: 3.33519,
    x2: 22.1292,
    y2: 7.87946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4166_311997",
    x1: 1.50084,
    y1: 5.11823,
    x2: 20.254,
    y2: 12.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "folder.07e56581d354e2381566abe18bdf8f5d.svg";